import { DecimalPipe, formatNumber } from '@angular/common';
import { InputCustomTypeEnum } from './input-custom-type.enum';

function isDigit(charCode) {
  return charCode >= 48 && charCode <= 57;
}

function isPhoneCharCode(charCode) {
  return !!String.fromCharCode(charCode).match(/[-()\d' ']/g);
}

function isPercentCharCode(charCode) {
  return !!String.fromCharCode(charCode).match(/[.,\d' ']/g);
}

function keepDigits(value) {
  return value.replace(/[^0-9\.\,]/g, '');
}

const defaultFn = {
  sanitizeFn: value => value,
  isValidKey: () => true,
  maskFn: value => value,
  unmaskFn: value => value
};

const NARROW_NO_BREAK_SPACE_CHAR = String.fromCharCode(8239);
const NO_BREAK_SPACE_CHAR = String.fromCharCode(160);
const ALIGN_RIGHT = 'text-align-right';

export const INPUT_MASK_CONFIGS = {
  [InputCustomTypeEnum.Currency]: {
    en: {
      inputPrefix: '$',
      type: 'tel',
      sanitizeFn: keepDigits,
      isValidKey: isDigit,
      maskFn: value => new DecimalPipe('en').transform(value, '1.0'),
      unmaskFn: value => value.replace(/,/g, '')
    },
    fr: {
      inputSuffix: '$',
      classes: [ALIGN_RIGHT],
      type: 'tel',
      sanitizeFn: keepDigits,
      isValidKey: isDigit,
      maskFn: value => formatNumber(value, 'fr', '1.0').replace(NARROW_NO_BREAK_SPACE_CHAR, NO_BREAK_SPACE_CHAR), // sur Safari le caractère n'est pas affiché, on le remplace par un espace normal
      unmaskFn: value => value.replace(NO_BREAK_SPACE_CHAR, '')
    }
  },
  percentage: {
    en: {
      inputSuffix: '%',
      classes: [ALIGN_RIGHT],
      sanitizeFn: keepDigits,
      isValidKey: isPercentCharCode,
      maskFn: value => {
        const formatedValue = parseFloat(value);
        return value ? formatNumber(formatedValue, 'en', '1.0-2') : '';
      },
      unmaskFn: value => value.replace(/,/g, '')
    },
    fr: {
      inputSuffix: '%',
      classes: [ALIGN_RIGHT],
      sanitizeFn: keepDigits,
      isValidKey: isPercentCharCode,
      maskFn: value => {
        const formatedValue = parseFloat(value.replace(',', '.'));
        return value ? formatNumber(formatedValue, 'fr', '1.0-2') : '';
      },
      unmaskFn: value => value.replace(' ', '')
    }
  },
  email: {
    en: {
      inputPrefix: 'email',
      type: 'email',
      ...defaultFn
    },
    fr: {
      inputPrefix: 'email',
      type: 'email',
      ...defaultFn
    }
  },
  [InputCustomTypeEnum.Telephone]: {
    en: {
      inputPrefix: 'tel',
      type: 'tel',
      sanitizeFn: keepDigits,
      isValidKey: isPhoneCharCode,
      maskFn: value => {
        const match = value.match(/^(\d{3})(\d{3})(\d{4})$/);
        return `${match[1]}-${match[2]}-${match[3]}`;
      },
      unmaskFn: value => value.replace(/\D/g, '')
    },
    fr: {
      inputPrefix: 'tel',
      type: 'tel',
      sanitizeFn: keepDigits,
      isValidKey: isPhoneCharCode,
      maskFn: value => {
        const match = value.match(/^(\d{3})(\d{3})(\d{4})$/);
        return match ? `${match[1]} ${match[2]}-${match[3]}` : value;
      },
      unmaskFn: value => value.replace(/\D/g, '')
    }
  },
  none: {
    en: {
      ...defaultFn
    },
    fr: {
      ...defaultFn
    }
  }
};
